/* THE DAILY SPA — interaction layer
   Scroll reveals, count-up numbers, header state, sticky ATC.
   Transform/opacity only; everything respects prefers-reduced-motion. */

(() => {
  'use strict';

  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ----- scroll reveals ------------------------------------------------ */
  const revealTargets = document.querySelectorAll('.ds-reveal, .ds-stagger');

  if (revealTargets.length && !reducedMotion && 'IntersectionObserver' in window) {
    const revealObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('ds-inview');
            revealObserver.unobserve(entry.target);
          }
        });
      },
      { rootMargin: '0px 0px -10% 0px', threshold: 0.1 }
    );
    revealTargets.forEach((el) => revealObserver.observe(el));
  } else {
    revealTargets.forEach((el) => el.classList.add('ds-inview'));
  }

  /* ----- count-up numbers ---------------------------------------------- */
  const counters = document.querySelectorAll('[data-ds-count]');

  const runCounter = (el) => {
    const target = parseFloat(el.dataset.dsCount);
    const suffix = el.dataset.dsSuffix || '';
    const duration = 1400;
    const start = performance.now();

    const tick = (now) => {
      const progress = Math.min((now - start) / duration, 1);
      const eased = 1 - Math.pow(1 - progress, 4);
      el.textContent = Math.round(target * eased).toLocaleString() + suffix;
      if (progress < 1) requestAnimationFrame(tick);
    };
    requestAnimationFrame(tick);
  };

  if (counters.length) {
    if (reducedMotion || !('IntersectionObserver' in window)) {
      counters.forEach((el) => {
        el.textContent =
          parseFloat(el.dataset.dsCount).toLocaleString() + (el.dataset.dsSuffix || '');
      });
    } else {
      const counterObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              runCounter(entry.target);
              counterObserver.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.6 }
      );
      counters.forEach((el) => counterObserver.observe(el));
    }
  }

  /* ----- header: transparent over hero → solid on scroll --------------- */
  const headerRoot = document.body;
  if (headerRoot.classList.contains('ds-header-transparent')) {
    /* offset the header by the lowest edge of whatever bars sit above it
       (presale bar, announcement bar) — bottoms don't double-count the way
       summed heights of nested elements do */
    const aboveHeader = document.querySelectorAll('.ds-presale, .announcement-bar-section, .utility-bar');
    const setOffset = () => {
      let bottom = 0;
      aboveHeader.forEach((el) => {
        bottom = Math.max(bottom, el.getBoundingClientRect().bottom + window.scrollY);
      });
      document.documentElement.style.setProperty('--ds-announcement-height', `${bottom}px`);
    };
    setOffset();
    window.addEventListener('resize', setOffset, { passive: true });

    const onScroll = () => {
      headerRoot.classList.toggle('ds-scrolled', window.scrollY > 50);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* ----- sticky add-to-cart bar (PDP) ----------------------------------- */
  const stickyBar = document.querySelector('.ds-sticky-atc');
  const mainBuyButtons = document.querySelector('.product-form__buttons');

  if (stickyBar && mainBuyButtons && 'IntersectionObserver' in window) {
    const atcObserver = new IntersectionObserver(
      ([entry]) => {
        stickyBar.classList.toggle(
          'ds-visible',
          !entry.isIntersecting && entry.boundingClientRect.top < 0
        );
      },
      { threshold: 0 }
    );
    atcObserver.observe(mainBuyButtons);

    const stickyButton = stickyBar.querySelector('[data-ds-sticky-submit]');
    if (stickyButton) {
      stickyButton.addEventListener('click', () => {
        const mainSubmit = mainBuyButtons.querySelector('button[type="submit"]');
        if (mainSubmit) mainSubmit.click();
      });
    }

    /* keep sticky price in sync with variant changes */
    document.addEventListener('change', (evt) => {
      if (!evt.target.closest('variant-selects, variant-radios')) return;
      window.setTimeout(() => {
        const livePrice = document.querySelector('.product__info-container .price__regular .price-item--regular');
        const stickyPrice = stickyBar.querySelector('.ds-sticky-atc__price');
        if (livePrice && stickyPrice) stickyPrice.textContent = livePrice.textContent.trim();
      }, 500);
    });
  }
})();
